<template>
  <div v-if="!isBookshelfLoading && getCurrentBookshelf" class="location_wrap">
    <div class="location">
      <span>{{ $t('library.subbar.7204') }}</span>
      <span class="svg_next">></span>
      <span>{{ $t('library.subbar.1465') }}</span>
      <span class="svg_next">></span>

      <div v-on-clickaway="closeListMenu" class="current">
        <div class="select_area">
          <div :class="{ active: isListMenuOpen }" class="select_item">
            <button
              v-if="!isBookshelfLoading"
              type="button"
              class="select_option"
              @click.prevent.stop="toggleListMenu"
            >
              <template v-if="$route.path === '/library'">
                <span class="txt">전체도서</span
                ><span class="arrow blind">열기</span>
              </template>
              <template v-else>
                <span class="txt">{{ getCurrentBookshelf.name }}</span>
                <span class="arrow blind">열기</span>
              </template>
            </button>

            <ul v-if="isListMenuOpen" class="select_list">
              <li :key="0">
                <a @click="navigateBookshelf('')">
                  전체도서
                </a>
              </li>
              <li v-for="(bookshelf, index) in getBookshelves" :key="index">
                <a @click="navigateBookshelf(bookshelf.id)">
                  {{ bookshelf.name }}
                </a>
              </li>
            </ul>
            <template v-if="isLibraryDetail">
              <span class="svg_next ml-1">></span>
              <span class="txt">{{
                $t('views.library.librarybookdetail.6338')
              }}</span>
              <!-- <span class="arrow blind"></span> -->
            </template>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isLibraryDetail" class="eplist_sort">
      <!-- SORT BOOKS MENU -->
      <!-- <ul v-if="!isMoveBookModeEnabled" class="board_sort">
        <li>
          <a
            :class="{ active: activeFilter === 'PD' }"
            :tabindex="isNiaMode ? 0 : false"
            @click="filterNotes('PD')"
            @keypress="filterNotes('PD')"
            ><span>{{ $t('library.subbar.3733') }}</span></a
          >
        </li>
        <li>
          <a
            :class="{ active: activeFilter === 'RD' }"
            :tabindex="isNiaMode ? 0 : false"
            @click="filterNotes('RD')"
            @keypress="filterNotes('RD')"
            ><span>{{ $t('library.subbar.5601') }}</span></a
          >
        </li>
        <!//--
          <li>
            <router-link :to="{ name: 'my_notes' }"
              ><span>{{ $t('library.subbar.9188') }}</span></router-link
            >
          </li>
          --//>
      </ul> -->
      <!-- MOVE SUB MENU -->
      <div class="btn_wrap">
        <div
          v-if="
            $route.name !== 'library_default' &&
            !isMoveBookModeEnabled &&
            getCurrentBookshelf.bookshelfTp !== 'PRS' &&
            getCurrentBookshelf.bookshelfTp !== 'CPN'
          "
          class="library_option start"
        >
          <button type="button" class="btn" @click="startSelectMode">
            <span class="c_icon"></span
            ><span class="an_t">{{ $t('library.subbar.6925') }}</span>
          </button>
        </div>
        <!-- 이동 취소 BUTTON -->
        <div v-if="isMoveBookModeEnabled" class="flex">
          <div class="library_option" @click="endSelectMode">
            <button type="button" class="btn">
              <span class="an_t">{{ $t('library.subbar.cancel') }}</span>
            </button>
          </div>
          <!-- 이동 moveListMenu BUTTON -->
          <div class="library_option ml-1" @click="toggleMoveListMenu">
            <button
              type="button"
              class="btn"
              :class="!getSelectedLibraryBooks.length ? 'disabled' : ''"
            >
              <span class="an_t">{{ $t('library.subbar.move') }}</span>
            </button>
          </div>
        </div>

        <div
          v-if="isMoveListMenuOpen && isMoveBookModeEnabled"
          class="library_option move"
        >
          <div v-on-clickaway="closeMoveListMenu" class="select_area">
            <div :class="{ active: isMoveListMenuOpen }" class="select_item">
              <!-- <button type="button" class="select_option btn">
                  <span class="an_t">이동</span>
                </button> -->
              <!-- 이동 메뉴-->
              <ul class="select_list">
                <li class="tit">
                  {{ $t('library.subbar.803')
                  }}<button
                    class="select_list_close an_a"
                    @click="toggleMoveListMenu"
                  >
                    <span class="svg_close"></span
                    ><span class="an_t">{{ $t('library.subbar.close') }}</span>
                  </button>
                </li>
                <li
                  v-for="(bookshelf, index) in baseBookshelves.filter(
                    (bs) => bs.id !== getCurrentBookshelf.id
                  )"
                  :key="index"
                >
                  <button
                    type="button"
                    class="list_option"
                    @click="moveLibraryBooks(bookshelf)"
                  >
                    {{ bookshelf.name }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- SLOT CONTENTS -->
  <!-- <slot /> -->
</template>

<script>
import { mapGetters } from 'vuex'
import { isNiaMode } from '@/store/constants'

import {
  BOOKSHELF_SET_CURRENT,
  BOOKSHELF_BOOK_GET_LIST,
  BOOKSHELF_BOOK_MOVE_BOOKS,
  UI_SHOW_SIDEBAR,
  UI_ENABLE_MOVE_BOOK_MODE,
  UI_DISABLE_MOVE_BOOK_MODE,
  UI_UNSELECT_ALL_BOOKS
} from '@/store/types'

export default {
  name: 'Subbar',
  data() {
    return {
      isListMenuOpen: false,
      isMoveListMenuOpen: false,
      activeFilter: 'PD',
      isNiaMode
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentBookshelf',
      'getBookshelves',
      'isBookshelfLoading',
      'isSidebarOpen',
      'isMoveBookModeEnabled',
      'getSelectedLibraryBooks'
    ]),
    isLibraryDetail() {
      return this.$route.name === 'library_book_detail'
    },
    baseBookshelves() {
      return this.getBookshelves.filter(
        (e) => e.bookshelfTp !== 'GFT' && e.bookshelfTp !== 'PRS'
      )
    }
  },
  watch: {
    getCurrentBookshelf() {
      this.endSelectMode()
    }
  },
  mounted() {
    if (this.getCurrentBookshelf) {
      return
    }
    const rp = this.$route.params.id
    this.navigateBookshelf(rp)
  },
  beforeDestroy() {
    this.endSelectMode()
  },
  methods: {
    navigateBookshelf(id) {
      this.$store.commit(BOOKSHELF_SET_CURRENT, id)
      this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST)
      if (id !== '') {
        this.$router.push({ name: 'library', params: { id } })
      } else {
        this.$router.push({ name: 'library_default' })
      }

      this.closeListMenu()
    },
    openSidebar() {
      this.$store.commit(UI_SHOW_SIDEBAR)
    },
    toggleListMenu() {
      this.isListMenuOpen = !this.isListMenuOpen
    },
    toggleMoveListMenu() {
      this.isMoveListMenuOpen = !this.isMoveListMenuOpen
    },
    closeMoveListMenu() {
      this.isMoveListMenuOpen = false
    },
    closeListMenu() {
      this.isListMenuOpen = false
    },
    startSelectMode() {
      this.$store.commit(UI_ENABLE_MOVE_BOOK_MODE)
    },
    endSelectMode() {
      this.$store.commit(UI_UNSELECT_ALL_BOOKS)
      this.$store.commit(UI_DISABLE_MOVE_BOOK_MODE)
    },
    filterNotes(value) {
      this.activeFilter = value
      this.$emit('sort', value)
    },
    async moveLibraryBooks(library) {
      if (!this.getSelectedLibraryBooks.length) return
      await this.$store.dispatch(BOOKSHELF_BOOK_MOVE_BOOKS, {
        to: library.id,
        books: this.getSelectedLibraryBooks
      })
      this.$store.commit(UI_UNSELECT_ALL_BOOKS)
      this.endSelectMode()
      this.closeMoveListMenu()
      await this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST, {
        page: 1
        // sort: 'PD'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.location_wrap {
  @media (min-width: 1440px) {
    max-width: 100%;
  }
  display: flex;
  justify-content: space-between;
  .eplist_sort {
    position: static;
    display: flex;
    align-items: center;
    .board_sort {
      margin-right: 24px;
    }
  }
}
@media screen and (max-width: 768px) {
  .location_wrap {
    flex-direction: column;
    .location {
      // display: none !important;
    }
    .eplist_sort {
      margin-top: 0;
      justify-content: space-between;
      .btn_wrap {
        margin-left: auto;
      }
      .board_sort {
        max-width: 168px;
        margin: 0;
      }
    }
  }
}
.ml-1 {
  margin-left: 8px;
}
.disabled {
  opacity: 0.5;
}
</style>
